// extracted by mini-css-extract-plugin
export default {"element":"Subtitle-module--element--8ec86"};